import { IBettingTypeSelectorsStore } from "@gp/offer";
import { BettingTypeSelectorsStore as DesktopBettingTypeSelector } from "@state/stores/offer/shared/BettingTypeSelectorsStore";
import { BettingTypeSelectorsStore as MobileBettingTypeSelector } from "@state/stores/offer/shared/BettingTypeSelectorsStore.mobile";
import { createContext } from "react";

export type TOfferOptionsContext = {
	bettingTypeSelectorsStore?:
		| MobileBettingTypeSelector
		| DesktopBettingTypeSelector
		| IBettingTypeSelectorsStore;
	shouldHideTopTag?: boolean;
	eventNavigation?: (eventId: string) => string;
	numberOfColumns?: number;
	/**
	 * Duration of highlighter score after change (in ms)
	 * @default 3500
	 */
	scoreChangeDuration?: number;
	/**
	 * If true, additional offer will display right below the row it was clicked on. This is default behaviour
	 * @default true
	 */
	enableInlineAdditionalOffer?: boolean;
	/**
	 * For live offer render set to true, otherwise is false.
	 * @default false
	 */
	isLive?: boolean;
	/**
	 * Used for hiding tournament name and category description on prematch offer pages
	 * @default false
	 */
	hideTournamentDescriptionIfSingleTournament?: boolean;
	/**
	 * Enable History data for tips and Event Info
	 * @default false
	 */
	isOfferHistory?: boolean;
	/**
	 * True when the current offer page shows exactly one tournament. Enables swipe mode
	 * in individual event rows.
	 * @default false
	 */
	isSingleTournament?: boolean;
};

export const OfferOptionsContext = createContext<TOfferOptionsContext | null>(
	null
);
